import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const MyCaseloadsWrapper = styled.div`
  display: flex;

  .my-caseloads-container {
    padding: 24px 16px;
    display: flex;
    width: 100%;
    flex-direction: column;
    border-radius: 8px;
    background-color: ${COLORS.cirrus_white};

    ${responsive.MOBILE`
      padding: 16px 8px;
    `}
  }
`;
